<template>
  <div style="font-size: 16px;color: #606266;margin: 0 30px">
    <div v-if="home !== ''">
    <el-row style="height: 35px">
      <el-col :span="12">
        <div class="left-name"><span>所属小区：</span></div>
        <div class="right-show-name">
          <span>{{getOnCommunity(home)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name"><span>所属区域：</span></div>
        <div class="right-show-name">
          <span>{{home.orglevelname}}</span>
        </div>
      </el-col>
    </el-row>
    <el-row style="height: 35px">
      <el-col :span="24">
        <div class="left-name"><span>家庭地址：</span></div>
        <div class="right-show-name">
          <el-input size="mini" v-if="isEditMsg" placeholder="请输入地址" v-model="home.address"></el-input>
          <span v-else>{{home.address}}</span>
        </div>
      </el-col>
    </el-row>
    <div style="clear: both"></div>
      <div v-if="isEditMsg" style="height: 1px;background-color: #ebebeb;"></div>
      <div style="margin-top: 20px" v-if="isEditMsg">
        <div class="send-btn" @click="checkCommit()"><span>提交审核</span></div>
      </div>
    </div>
    <div v-else style="height: 100px;line-height: 100px;text-align: center">
      <span>暂无家信息</span>
    </div>
    <div class="title-top-alarm">
      <div>
        <span>家庭成员</span>
      </div>
      <div class="line-title"></div>
    </div>
    <div style="max-height: 220px;overflow-y: auto;margin: 0 20px">
      <el-table
        size="mini"
        :data="tableData"
        border
        style="width: 100%;"
        highlight-current-row>
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="60"
          align="center">
        </el-table-column>
        <el-table-column
          label="性别"
          width="50"
          align="center">
          <template slot-scope="scope">
            <span>{{getSex(scope.row.sex)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="birthday"
          label="出生日期"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话号码"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          prop="timelist"
          label="接听电话时间段"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          prop="circumstances"
          label="特殊情况"
          min-width="90"
          align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {addcheckinfo} from '../../../api/serviceObject'

export default {
  name: 'homeDetails',
  props: {
    homeObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      home: '',
      tableData: [],
      orgcommunitys: [],
      isEditMsg: false
    }
  },
  created () {
    /* 1、doHandleAlarm.vue处理事件 2、callPhonePage.vue 客服关爱  3、alarmDetailsNew.vue 事件统计详情弹窗 */
    // console.log(this.homeObj)
    this.home = this.homeObj.home
    this.tableData = this.homeObj.oldpersons
    this.orgcommunitys = this.homeObj.orgcommunitys
    if (this.homeObj.isEdit && this.$store.state.user.customerservicetag === 1) {
      this.isEditMsg = true
    }
  },
  methods: {
    // 提交审核
    checkCommit () {
      let changeinfo = {
        homeinfo: this.home,
        personinfo: ''
      }
      let data = {
        hid: this.home.id,
        pid: this.tableData.length > 0 ? this.tableData[0].id : 0,
        changeinfo: JSON.stringify(changeinfo)
      }
      console.log(data)
      addcheckinfo(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功提交审核',
          type: 'success',
          duration: 2000
        })
        this.$emit('handleAlarmHome', this.home)
      }).catch(() => {})
    },
    getOnCommunity (row) {
      for (let i = 0; i < this.orgcommunitys.length; i++) {
        if (row.cid === this.orgcommunitys[i].id) {
          return this.orgcommunitys[i].name
        }
      }
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticalform/childComponents/homeDetails.vue